import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _28cb8a94 = () => interopDefault(import('../src/pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _1796addd = () => interopDefault(import('../src/pages/cookie-policy.vue' /* webpackChunkName: "pages/cookie-policy" */))
const _6f783a96 = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _43a77e82 = () => interopDefault(import('../src/pages/manage-booking/index.vue' /* webpackChunkName: "pages/manage-booking/index" */))
const _08a07eca = () => interopDefault(import('../src/pages/modify-checkout.vue' /* webpackChunkName: "pages/modify-checkout" */))
const _75aaa136 = () => interopDefault(import('../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _22ca811e = () => interopDefault(import('../src/pages/quote.vue' /* webpackChunkName: "pages/quote" */))
const _25121c5a = () => interopDefault(import('../src/pages/receipt.vue' /* webpackChunkName: "pages/receipt" */))
const _7b48d114 = () => interopDefault(import('../src/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _204cdc05 = () => interopDefault(import('../src/pages/search-booking/index.vue' /* webpackChunkName: "pages/search-booking/index" */))
const _ef27727c = () => interopDefault(import('../src/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _2c8e9418 = () => interopDefault(import('../src/pages/travel-extras.vue' /* webpackChunkName: "pages/travel-extras" */))
const _ee792a9c = () => interopDefault(import('../src/pages/unsupported-browser.vue' /* webpackChunkName: "pages/unsupported-browser" */))
const _20811dfd = () => interopDefault(import('../src/pages/manage-booking/cancel/index.vue' /* webpackChunkName: "pages/manage-booking/cancel/index" */))
const _4f94653a = () => interopDefault(import('../src/pages/manage-booking/modify.vue' /* webpackChunkName: "pages/manage-booking/modify" */))
const _5fd8fee8 = () => interopDefault(import('../src/pages/manage-booking/receipt.vue' /* webpackChunkName: "pages/manage-booking/receipt" */))
const _2a3ed7be = () => interopDefault(import('../src/pages/manage-booking/update-details.vue' /* webpackChunkName: "pages/manage-booking/update-details" */))
const _82aab24e = () => interopDefault(import('../src/pages/select-extras/product/index.vue' /* webpackChunkName: "pages/select-extras/product/index" */))
const _6cc8aba3 = () => interopDefault(import('../src/pages/manage-booking/cancel/receipt.vue' /* webpackChunkName: "pages/manage-booking/cancel/receipt" */))
const _4b0d5074 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _28cb8a94,
    name: "checkout"
  }, {
    path: "/cookie-policy",
    component: _1796addd,
    name: "cookie-policy"
  }, {
    path: "/maintenance",
    component: _6f783a96,
    name: "maintenance"
  }, {
    path: "/manage-booking",
    component: _43a77e82,
    name: "manage-booking"
  }, {
    path: "/modify-checkout",
    component: _08a07eca,
    name: "modify-checkout"
  }, {
    path: "/privacy-policy",
    component: _75aaa136,
    name: "privacy-policy"
  }, {
    path: "/quote",
    component: _22ca811e,
    name: "quote"
  }, {
    path: "/receipt",
    component: _25121c5a,
    name: "receipt"
  }, {
    path: "/search",
    component: _7b48d114,
    name: "search"
  }, {
    path: "/search-booking",
    component: _204cdc05,
    name: "search-booking"
  }, {
    path: "/terms-and-conditions",
    component: _ef27727c,
    name: "terms-and-conditions"
  }, {
    path: "/travel-extras",
    component: _2c8e9418,
    name: "travel-extras"
  }, {
    path: "/unsupported-browser",
    component: _ee792a9c,
    name: "unsupported-browser"
  }, {
    path: "/manage-booking/cancel",
    component: _20811dfd,
    name: "manage-booking-cancel"
  }, {
    path: "/manage-booking/modify",
    component: _4f94653a,
    name: "manage-booking-modify"
  }, {
    path: "/manage-booking/receipt",
    component: _5fd8fee8,
    name: "manage-booking-receipt"
  }, {
    path: "/manage-booking/update-details",
    component: _2a3ed7be,
    name: "manage-booking-update-details"
  }, {
    path: "/select-extras/product",
    component: _82aab24e,
    name: "select-extras-product"
  }, {
    path: "/manage-booking/cancel/receipt",
    component: _6cc8aba3,
    name: "manage-booking-cancel-receipt"
  }, {
    path: "/",
    component: _4b0d5074,
    name: "index"
  }, {
    path: "/dedicated",
    component: _4b0d5074,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-index"
  }, {
    path: "/dedicated/search",
    component: _7b48d114,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-search"
  }, {
    path: "/dedicated/select-extras/product",
    component: _82aab24e,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-select-extras"
  }, {
    path: "/dedicated/travel-extras",
    component: _2c8e9418,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-travel-extras"
  }, {
    path: "/dedicated/manage-booking/modify",
    component: _4f94653a,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-modify"
  }, {
    path: "/dedicated/receipt",
    component: _25121c5a,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-receipt"
  }, {
    path: "/dedicated/checkout",
    component: _28cb8a94,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-checkout"
  }, {
    path: "/dedicated/modify-checkout",
    component: _08a07eca,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-modify-checkout"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
